import React from "react";
import "./taskSpan.css";

/**
 * Planned WORK span for one Task row (display only): Start -> Expected
 * Completion, where Expected = Start + Planned Duration + Organization Work
 * Schedule (see helpers/planning/planningModel.js taskWorkSpan). One piece per
 * run of working days; non-working weekdays / dates are gaps, never productive
 * days. Due is NOT what sets the length: it stays the separate deadline marker.
 * Green = reported progress (share of the working days, in order), gold =
 * remaining. No Start, no Duration or no known schedule -> nothing is drawn.
 */
export function TaskSpanBar({ node, startIdx, endIdx = Infinity, dayW }) {
  const segments = node?.workSegments || [];
  if (!segments.length) return null;
  const totalDays = segments.reduce((n, s) => n + (s.end - s.start + 1), 0);
  const progress = node.completed ? 100 : node.progress == null ? 0 : node.progress;
  const doneDays = (progress / 100) * totalDays;
  const label = `Work ${node.startDate} to expected ${node.expectedDate}${node.date ? ` · due ${node.date}` : ""}${
    node.expectedAfterDue ? " (expected after due)" : ""
  }${node.progress == null ? "" : ` · ${node.progress}% reported`}`;
  let offset = 0;
  const pieces = [];
  segments.forEach((seg, i) => {
    const len = seg.end - seg.start + 1;
    const fill = Math.max(0, Math.min(1, (doneDays - offset) / len));
    offset += len;
    const from = Math.max(seg.start, startIdx);
    const to = Math.min(seg.end, endIdx);
    if (to < from) return;
    pieces.push(
      <span
        key={i}
        className={`tk-span${node.completed ? " is-done" : ""}${node.expectedAfterDue ? " is-late" : ""}${
          from > seg.start ? " is-cut-start" : ""
        }`}
        style={{ left: Math.round((from - startIdx) * dayW + 3), width: Math.max(8, Math.round((to - from + 1) * dayW - 6)) }}
        data-testid="task-span"
        data-start={seg.start}
        data-end={seg.end}
        data-progress={node.progress == null ? "" : node.progress}
        title={label}
        aria-hidden="true"
      >
        <span className="tk-span__done" style={{ width: `${Math.round(fill * 100)}%` }} />
      </span>,
    );
  });
  return <>{pieces}</>;
}
